<template>
    <div class="paginator" v-if="!autoHide || itemCount > 0">
        <span class="current-view">{{ currentView }}</span>
        <a @click.prevent="goPrevious" href="#" :class="{ disabled: backDisabled, 'material-icons': true }"
            >chevron_left</a
        >
        <a @click.prevent="goNext" href="#" :class="{ disabled: forwardDisabled, 'material-icons': true }"
            >chevron_right</a
        >
    </div>
</template>
<script>
const minimumPage = 1

export default {
    name: 'Paginator',
    props: {
        autoHide: {
            type: Boolean,
            default: false,
        },
        currentPage: {
            type: Number,
            default: minimumPage,
            required: false,
        },
        pageSize: {
            type: Number,
            default: 20,
        },
        itemCount: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        zeroBasedPage() {
            return this.currentPage - 1
        },
        start() {
            return this.pageSize * this.zeroBasedPage + 1
        },
        end() {
            var end = this.pageSize * (this.zeroBasedPage + 1)
            return Math.min(end, this.itemCount)
        },
        lastPage() {
            var lastPage = Math.floor(this.itemCount / this.pageSize)
            if (lastPage * this.pageSize < this.itemCount) {
                lastPage++
            }
            return lastPage
        },
        currentView() {
            return `${this.start} - ${this.end} of ${this.itemCount}`
        },
        backDisabled() {
            return this.currentPage <= minimumPage
        },
        forwardDisabled() {
            return this.currentPage >= this.lastPage
        },
    },
    methods: {
        goPrevious() {
            if (!this.backDisabled) {
                this.$emit('update:currentPage', this.currentPage - 1)
            }
        },
        goNext() {
            if (!this.forwardDisabled) {
                this.$emit('update:currentPage', this.currentPage + 1)
            }
        },
    },
}
</script>
<style>
.paginator {
    float: right;

    & > * {
        line-height: 24px;
        display: inline-block;
        overflow: hidden;
    }

    .current-view {
        font-size: var(--font-size-detail);
        color: var(--color-alpha-4);
        margin-right: 24px;
    }

    a {
        background-color: var(--color-primary-100);
        color: var(--color-primary-500);
        margin-left: 8px;
        text-align: center;
        width: 24px;

        &.disabled {
            opacity: 0.2;
        }
    }
}
.footer-paginator {
    clear: both;
    height: 24px;
    margin: 32px 0 88px 0;
}
</style>
